"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _WireObject2 = _interopRequireDefault(require("../WireObject"));

var _creative = require("../../constants/creative");

var _isBoolean = _interopRequireDefault(require("../../utils/object/isBoolean"));

var _isEmptyString = _interopRequireDefault(require("../../utils/object/isEmptyString"));

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var _removeUnusedKeys = _interopRequireDefault(require("../../utils/object/removeUnusedKeys"));

var _getGuid = _interopRequireDefault(require("../../utils/guid/getGuid"));

var _deepCopy = _interopRequireDefault(require("../../utils/object/deepCopy"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CreativeDocumentContent = /*#__PURE__*/function (_WireObject) {
  (0, _inherits2["default"])(CreativeDocumentContent, _WireObject);

  var _super = _createSuper(CreativeDocumentContent);

  /**
   * String indicating alignment value (LEFT, RIGHT, CENTER) for text. From TEXT_ALIGNMENT
   */

  /**
   * Boolean indicating that this content is audible (can be set by user)
   */

  /**
   * List of IDs for elements that are children of this content if it is a group type. (element group, element effect group)
   */

  /**
   * String ID of this content item
   */

  /**
   * String indicating the contentType of this content. Must be from CONTENT_TYPE
   */

  /**
   * String ID of the creativeField (DataStore) used when populating this content from import/design swap
   */

  /**
   * Number in seconds indicating the end time of the clip within a video to be used in this content
   */

  /**
   * String Hex indicating the fill color for this content. Usage varies based on type (shape, text)
   */

  /**
   * String indicating the font to use for this content (text only)
   */

  /**
   * String indicating the font size to use for this content (text only)
   */

  /**
   * Boolean indicating that this content is open in the UI. For group types only
   */

  /**
   * Number indicating the spacing between characters in text (text only)
   */

  /**
   * Number indicating the spacing between lines in text (text only)
   */

  /**
   * String ID of the media object associated with this content. Can be null because groups do no thave media.
   */

  /**
   * Number in pixels of the natural rendered height of the content (text)
   */

  /**
   * Number in pixels of the natural rendered width of the content (text)
   */

  /**
   * String value indicating the overflow behavior on the x axis. From OVERFLOW_X
   */

  /**
   * String value indicating the overflow behavior on the y axis. From OVERFLOW_Y
   */

  /**
   * Number in pixels of the padding used for this content (text)
   */

  /**
   * String indicating the rendered (what is actually measured) font size to use for this content (text only)
   */

  /**
   * String representing the shape type of this content (shape). From SHAPE
   */

  /**
   * Number in seconds indicating the start time of the clip within a video to be used in this content
   */

  /**
   * String representing text stroke color
   */

  /**
   * Number representing text stroke width
   */

  /**
   * Object containing the properties for the selected text effect for this content (text)
   * TODO make Model
   */

  /**
   * Object containing the properties for the different types of text fill for this content (text)
   * TODO make Model
   */

  /**
   * Array of text lines, used to ensure text measurement consistency between client and server (text)
   */

  /**
   * String containing the text configured on this content (text)
   */

  /**
   * String value indicating the text version. SVG or CANVAS
   */

  /**
   * Object containing the properties for the text wrapping options for this content (text)
   * TODO make Model
   */

  /**
   * String indicating vertical alignment value (BOTTOM, MIDDLE, TOP)) for text. From VERTICAL_TEXT_ALIGNMENT
   */

  /**
   * Boolean indicating that this content is visible in the canvas (can be set by user)
   */

  /**
   * @param {String} contentType - Content type from the CONTENT_TYPE constant.
   * @param {String|null} contentId - ID fo the content, if not supplied a new one will be generated.
   * @param {String|null} mediaId - ID of the associated media (optional for some content types).
   */
  function CreativeDocumentContent(contentType) {
    var _this;

    var contentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var mediaId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    (0, _classCallCheck2["default"])(this, CreativeDocumentContent);

    if ((0, _isEmptyString["default"])(contentType) || (0, _isNil["default"])(_creative.CONTENT_TYPE[contentType.toUpperCase()])) {
      throw new Error("CreativeDocumentContent must have a valid contentType, ".concat(contentType, ", ").concat(contentId, ", ").concat(mediaId));
    }

    _this = _super.call(this);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_alignment", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_audible", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_contentElementIds", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_contentId", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_contentType", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_creativeFieldId", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_end", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_fillColor", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_font", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_fontSize", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isOpen", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_letterSpacing", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_lineSpacing", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_mediaId", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_naturalHeight", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_naturalWidth", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_overflowX", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_overflowY", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_padding", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedFontSize", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_shape", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_start", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_strokeColor", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_strokeWidth", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_textEffect", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_textFill", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_textLines", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_textString", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_textType", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_textWrap", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_verticalAlignment", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_visible", void 0);
    _this._contentType = contentType.toUpperCase();
    _this._contentId = (0, _isEmptyString["default"])(contentId) ? CreativeDocumentContent.getId() : contentId;
    _this._mediaId = mediaId;
    _this._contentType = contentType;
    _this._contentId = contentId;
    return _this;
  }

  (0, _createClass2["default"])(CreativeDocumentContent, [{
    key: "copy",
    value: function copy() {
      var json = this.toJSON();
      return CreativeDocumentContent.fromJSON(json);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var contentObj = {
        alignment: this.alignment,
        audible: this.audible,
        contentElementIds: this.contentElementIds,
        contentId: this.contentId,
        contentType: this.contentType,
        creativeFieldId: this.creativeFieldId,
        end: this.end,
        fillColor: this.fillColor,
        font: this.font,
        fontSize: this.fontSize,
        isOpen: this.isOpen,
        letterSpacing: this.letterSpacing,
        lineSpacing: this.lineSpacing,
        mediaId: this.mediaId,
        naturalHeight: this.naturalHeight,
        naturalWidth: this.naturalWidth,
        overflowX: this.overflowX,
        overflowY: this.overflowY,
        padding: this.padding,
        renderedFontSize: this.renderedFontSize,
        shape: this.shape,
        start: this.start,
        strokeColor: this.strokeColor,
        strokeWidth: this.strokeWidth,
        textEffect: this.textEffect,
        textFill: this.textFill,
        textLines: this.textLines,
        textString: this.textString,
        textType: this.textType,
        textWrap: this.textWrap,
        verticalAlignment: this.verticalAlignment,
        visible: this.visible
      };
      return (0, _removeUnusedKeys["default"])(contentObj);
    }
  }, {
    key: "alignment",
    get: function get() {
      return this._alignment;
    },
    set: function set(value) {
      this._alignment = value;
    }
  }, {
    key: "audible",
    get: function get() {
      return this._audible;
    },
    set: function set(value) {
      this._audible = value;
    }
  }, {
    key: "contentElementIds",
    get: function get() {
      return this._contentElementIds;
    },
    set: function set(value) {
      this._contentElementIds = value;
    }
  }, {
    key: "contentId",
    get: function get() {
      return this._contentId;
    },
    set: function set(value) {
      this._contentId = value;
    }
  }, {
    key: "contentType",
    get: function get() {
      return this._contentType;
    },
    set: function set(value) {
      this._contentType = value;
    }
  }, {
    key: "creativeFieldId",
    get: function get() {
      return this._creativeFieldId;
    },
    set: function set(value) {
      this._creativeFieldId = value;
    }
  }, {
    key: "end",
    get: function get() {
      return this._end;
    },
    set: function set(value) {
      this._end = value;
    }
  }, {
    key: "fillColor",
    get: function get() {
      return this._fillColor;
    },
    set: function set(value) {
      this._fillColor = value;
    }
  }, {
    key: "font",
    get: function get() {
      return this._font;
    },
    set: function set(value) {
      this._font = value;
    }
  }, {
    key: "fontSize",
    get: function get() {
      return this._fontSize;
    },
    set: function set(value) {
      this._fontSize = value;
    }
  }, {
    key: "isOpen",
    get: function get() {
      return this._isOpen;
    },
    set: function set(value) {
      this._isOpen = value;
    }
  }, {
    key: "letterSpacing",
    get: function get() {
      return this._letterSpacing;
    },
    set: function set(value) {
      this._letterSpacing = value;
    }
  }, {
    key: "lineSpacing",
    get: function get() {
      return this._lineSpacing;
    },
    set: function set(value) {
      this._lineSpacing = value;
    }
  }, {
    key: "mediaId",
    get: function get() {
      return this._mediaId;
    },
    set: function set(value) {
      this._mediaId = value;
    }
  }, {
    key: "naturalHeight",
    get: function get() {
      return this._naturalHeight;
    },
    set: function set(value) {
      this._naturalHeight = value;
    }
  }, {
    key: "naturalWidth",
    get: function get() {
      return this._naturalWidth;
    },
    set: function set(value) {
      this._naturalWidth = value;
    }
  }, {
    key: "overflowX",
    get: function get() {
      return this._overflowX;
    },
    set: function set(value) {
      this._overflowX = value;
    }
  }, {
    key: "overflowY",
    get: function get() {
      return this._overflowY;
    },
    set: function set(value) {
      this._overflowY = value;
    }
  }, {
    key: "padding",
    get: function get() {
      return this._padding;
    },
    set: function set(value) {
      this._padding = value;
    }
  }, {
    key: "shape",
    get: function get() {
      return this._shape;
    },
    set: function set(value) {
      this._shape = value;
    }
  }, {
    key: "start",
    get: function get() {
      return this._start;
    },
    set: function set(value) {
      this._start = value;
    }
  }, {
    key: "strokeColor",
    get: function get() {
      return this._strokeColor;
    },
    set: function set(value) {
      this._strokeColor = value;
    }
  }, {
    key: "strokeWidth",
    get: function get() {
      return this._strokeWidth;
    },
    set: function set(value) {
      this._strokeWidth = value;
    }
  }, {
    key: "renderedFontSize",
    get: function get() {
      return this._renderedFontSize;
    },
    set: function set(value) {
      this._renderedFontSize = value;
    }
  }, {
    key: "textEffect",
    get: function get() {
      return this._textEffect;
    },
    set: function set(value) {
      this._textEffect = value;
    }
  }, {
    key: "textFill",
    get: function get() {
      return this._textFill;
    },
    set: function set(value) {
      this._textFill = value;
    }
  }, {
    key: "textLines",
    get: function get() {
      return this._textLines;
    },
    set: function set(value) {
      this._textLines = value;
    }
  }, {
    key: "textString",
    get: function get() {
      return this._textString;
    },
    set: function set(value) {
      this._textString = value;
    }
  }, {
    key: "textType",
    get: function get() {
      return this._textType;
    },
    set: function set(value) {
      this._textType = value;
    }
  }, {
    key: "textWrap",
    get: function get() {
      return this._textWrap;
    },
    set: function set(value) {
      this._textWrap = value;
    }
  }, {
    key: "verticalAlignment",
    get: function get() {
      return this._verticalAlignment;
    },
    set: function set(value) {
      this._verticalAlignment = value;
    }
  }, {
    key: "visible",
    get: function get() {
      return this._visible;
    },
    set: function set(value) {
      this._visible = value;
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(inContent) {
      var alignment = inContent.alignment,
          audible = inContent.audible,
          contentElementIds = inContent.contentElementIds,
          contentId = inContent.contentId,
          contentType = inContent.contentType,
          creativeFieldId = inContent.creativeFieldId,
          end = inContent.end,
          fillColor = inContent.fillColor,
          font = inContent.font,
          fontSize = inContent.fontSize,
          isOpen = inContent.isOpen,
          letterSpacing = inContent.letterSpacing,
          lineSpacing = inContent.lineSpacing,
          mediaId = inContent.mediaId,
          naturalHeight = inContent.naturalHeight,
          naturalWidth = inContent.naturalWidth,
          overflowX = inContent.overflowX,
          overflowY = inContent.overflowY,
          padding = inContent.padding,
          renderedFontSize = inContent.renderedFontSize,
          shape = inContent.shape,
          start = inContent.start,
          strokeColor = inContent.strokeColor,
          strokeWidth = inContent.strokeWidth,
          textEffect = inContent.textEffect,
          textFill = inContent.textFill,
          textLines = inContent.textLines,
          textString = inContent.textString,
          textType = inContent.textType,
          textWrap = inContent.textWrap,
          verticalAlignment = inContent.verticalAlignment,
          visible = inContent.visible;
      var creativeDocumentContent = new CreativeDocumentContent(contentType, contentId, mediaId);
      creativeDocumentContent.alignment = alignment;
      creativeDocumentContent.contentElementIds = (0, _deepCopy["default"])(contentElementIds); // deepCopy instead of spread because it could be nil

      creativeDocumentContent.creativeFieldId = creativeFieldId;
      creativeDocumentContent.end = end;
      creativeDocumentContent.fillColor = fillColor;
      creativeDocumentContent.font = font;
      creativeDocumentContent.fontSize = fontSize;
      creativeDocumentContent.isOpen = isOpen;
      creativeDocumentContent.letterSpacing = letterSpacing;
      creativeDocumentContent.lineSpacing = lineSpacing;
      creativeDocumentContent.naturalHeight = naturalHeight;
      creativeDocumentContent.naturalWidth = naturalWidth;
      creativeDocumentContent.overflowX = overflowX;
      creativeDocumentContent.overflowY = overflowY;
      creativeDocumentContent.padding = padding;
      creativeDocumentContent.renderedFontSize = renderedFontSize;
      creativeDocumentContent.shape = shape;
      creativeDocumentContent.start = start;
      creativeDocumentContent.strokeColor = strokeColor;
      creativeDocumentContent.strokeWidth = strokeWidth;
      creativeDocumentContent.textEffect = (0, _deepCopy["default"])(textEffect);
      creativeDocumentContent.textFill = textFill;
      creativeDocumentContent.textLines = (0, _deepCopy["default"])(textLines); // deepCopy instead of spread because it could be nil

      creativeDocumentContent.textString = textString;
      creativeDocumentContent.textType = textType;
      creativeDocumentContent.textWrap = (0, _deepCopy["default"])(textWrap);
      creativeDocumentContent.verticalAlignment = verticalAlignment; // These have defaults if not set.

      creativeDocumentContent.audible = (0, _isBoolean["default"])(audible) ? audible : _creative.AUDIBLE_CONTENT_TYPES.has(contentType);
      creativeDocumentContent.visible = (0, _isBoolean["default"])(visible) ? visible : !_creative.INVISIBLE_CONTENT_TYPES.has(contentType);
      return creativeDocumentContent;
    }
  }, {
    key: "getId",
    value: function getId() {
      return "content-".concat((0, _getGuid["default"])());
    }
  }]);
  return CreativeDocumentContent;
}(_WireObject2["default"]);

exports["default"] = CreativeDocumentContent;